
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BoPanel, IOnOffHandlers } from 'bonomo';
import { IBusinessClient } from '@/model/BusinessClient/businessClientInterfaces';
import { IAuthUserData } from '@/store/modules/authModule';
import { EPermissionActions } from '@/model/EPermissionActions';
import Datim from '@/components/shared/Datim.vue';
import BusinessClientNav from '@/components/businessClient/widget/BusinessClientNav.vue';

const clientModule = namespace('clientModule');
const authModule = namespace('authModule');

@Component({
  name: 'BusinessClient',
  components: { BoPanel, Datim, BusinessClientNav },
})
export default class BusinessClient extends Vue {
  @Prop()
  protected clientId!: number;

  @clientModule.Getter('businessClient')
  protected client!: IBusinessClient;

  @clientModule.Action('fetchBusinessClient')
  private fetchClient!: (id: number) => Promise<any>;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  protected loading: boolean = true;
  private subscribes: IOnOffHandlers = {};

  get canEdit(): boolean {
    return this.$canAction(EPermissionActions.ACTION_BUSINESS_CLIENTS_UPDATE);
  }

  created() {
    this.subscribes = this.$ons({});
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  loadData() {
    this.fetchClient(this.clientId);
  }
}
